import { MantineThemeOverride } from '@mantine/core';

export type HighlightTheme = NonNullable<MantineThemeOverride['components']>['Highlight'];

export const Highlight: HighlightTheme = {
  // todo: define
};
